module.exports = __webpack_public_path__ + "img/Reset.b8a8327e.png";